var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlasses(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4084 15.7604H19.9695V17.2992H21.4084V15.7604Z",
    fill: "#24292A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9695 15.7604H18.5305V17.2992H19.9695V15.7604Z",
    fill: "#24292A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5306 15.7604H17.0917V17.2992H18.5306V15.7604Z",
    fill: "#24292A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0659 20.4044H15.627V21.9433H17.0659V20.4044Z",
    fill: "#24292A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0659 18.8655H15.627V20.4044H17.0659V18.8655Z",
    fill: "#24292A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0659 17.3268H15.627V18.8657H17.0659V17.3268Z",
    fill: "#24292A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0659 15.7604H15.627V17.2992H17.0659V15.7604Z",
    fill: "#24292A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.627 21.9432H14.1881V23.4821H15.627V21.9432Z",
    fill: "#24292A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.627 20.4044H14.1881V21.9433H15.627V20.4044Z",
    fill: "#24292A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.627 18.8655H14.1881V20.4044H15.627V18.8655Z",
    fill: "#24292A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.627 17.3268H14.1881V18.8657H15.627V17.3268Z",
    fill: "#EDEFEF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.627 15.7604H14.1881V17.2992H15.627V15.7604Z",
    fill: "#24292A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.627 14.2214H14.1881V15.7603H15.627V14.2214Z",
    fill: "#24292A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1881 23.5098H12.7491V25.0486H14.1881V23.5098Z",
    fill: "#24292A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1881 21.9432H12.7491V23.4821H14.1881V21.9432Z",
    fill: "#24292A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1881 20.4044H12.7491V21.9433H14.1881V20.4044Z",
    fill: "#EDEFEF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1881 18.8655H12.7491V20.4044H14.1881V18.8655Z",
    fill: "#EDEFEF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1881 17.3268H12.7491V18.8657H14.1881V17.3268Z",
    fill: "#24292A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1881 15.7604H12.7491V17.2992H14.1881V15.7604Z",
    fill: "#24292A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1881 14.2214H12.7491V15.7603H14.1881V14.2214Z",
    fill: "#24292A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1881 12.6826H12.7491V14.2215H14.1881V12.6826Z",
    fill: "#24292A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7491 23.5098H11.3102V25.0486H12.7491V23.5098Z",
    fill: "#24292A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7491 21.9432H11.3102V23.4821H12.7491V21.9432Z",
    fill: "#EDEFEF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7491 20.4044H11.3102V21.9433H12.7491V20.4044Z",
    fill: "#24292A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7491 18.8655H11.3102V20.4044H12.7491V18.8655Z",
    fill: "#24292A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7491 17.3268H11.3102V18.8657H12.7491V17.3268Z",
    fill: "#24292A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7491 15.7604H11.3102V17.2992H12.7491V15.7604Z",
    fill: "#24292A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7491 14.2214H11.3102V15.7603H12.7491V14.2214Z",
    fill: "#24292A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7491 12.6826H11.3102V14.2215H12.7491V12.6826Z",
    fill: "#24292A"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3103 23.5098H9.87134V25.0486H11.3103V23.5098Z",
    fill: "#24292A"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3103 21.9432H9.87134V23.4821H11.3103V21.9432Z",
    fill: "#EDEFEF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3103 20.4044H9.87134V21.9433H11.3103V20.4044Z",
    fill: "#24292A"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3103 18.8655H9.87134V20.4044H11.3103V18.8655Z",
    fill: "#24292A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3103 17.3268H9.87134V18.8657H11.3103V17.3268Z",
    fill: "#24292A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3103 15.7604H9.87134V17.2992H11.3103V15.7604Z",
    fill: "#24292A"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3103 14.2214H9.87134V15.7603H11.3103V14.2214Z",
    fill: "#24292A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3103 12.6826H9.87134V14.2215H11.3103V12.6826Z",
    fill: "#24292A"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84567 23.5098H8.40674V25.0486H9.84567V23.5098Z",
    fill: "#24292A"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84567 21.9432H8.40674V23.4821H9.84567V21.9432Z",
    fill: "#24292A"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84567 20.4044H8.40674V21.9433H9.84567V20.4044Z",
    fill: "#24292A"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84567 18.8655H8.40674V20.4044H9.84567V18.8655Z",
    fill: "#24292A"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84567 17.3268H8.40674V18.8657H9.84567V17.3268Z",
    fill: "#24292A"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84567 15.7604H8.40674V17.2992H9.84567V15.7604Z",
    fill: "#24292A"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84567 14.2214H8.40674V15.7603H9.84567V14.2214Z",
    fill: "#24292A"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84567 12.6826H8.40674V14.2215H9.84567V12.6826Z",
    fill: "#24292A"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40659 23.5098H6.96765V25.0486H8.40659V23.5098Z",
    fill: "#24292A"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40659 21.9432H6.96765V23.4821H8.40659V21.9432Z",
    fill: "#24292A"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40659 20.4044H6.96765V21.9433H8.40659V20.4044Z",
    fill: "#24292A"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40659 18.8655H6.96765V20.4044H8.40659V18.8655Z",
    fill: "#24292A"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40659 17.3268H6.96765V18.8657H8.40659V17.3268Z",
    fill: "#24292A"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40659 15.7604H6.96765V17.2992H8.40659V15.7604Z",
    fill: "#24292A"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40659 14.2214H6.96765V15.7603H8.40659V14.2214Z",
    fill: "#24292A"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40659 12.6826H6.96765V14.2215H8.40659V12.6826Z",
    fill: "#24292A"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96762 23.5098H5.52869V25.0486H6.96762V23.5098Z",
    fill: "#24292A"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96762 21.9432H5.52869V23.4821H6.96762V21.9432Z",
    fill: "#24292A"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96762 20.4044H5.52869V21.9433H6.96762V20.4044Z",
    fill: "#24292A"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96762 18.8655H5.52869V20.4044H6.96762V18.8655Z",
    fill: "#24292A"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96762 17.3268H5.52869V18.8657H6.96762V17.3268Z",
    fill: "#24292A"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96762 15.7604H5.52869V17.2992H6.96762V15.7604Z",
    fill: "#24292A"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96762 14.2214H5.52869V15.7603H6.96762V14.2214Z",
    fill: "#24292A"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96762 12.6826H5.52869V14.2215H6.96762V12.6826Z",
    fill: "#24292A"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52878 23.5098H4.08984V25.0486H5.52878V23.5098Z",
    fill: "#24292A"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52878 21.9432H4.08984V23.4821H5.52878V21.9432Z",
    fill: "#24292A"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52878 20.4044H4.08984V21.9433H5.52878V20.4044Z",
    fill: "#24292A"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52878 18.8655H4.08984V20.4044H5.52878V18.8655Z",
    fill: "#24292A"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52878 17.3268H4.08984V18.8657H5.52878V17.3268Z",
    fill: "#24292A"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52878 15.7604H4.08984V17.2992H5.52878V15.7604Z",
    fill: "#24292A"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52878 14.2214H4.08984V15.7603H5.52878V14.2214Z",
    fill: "#24292A"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52878 12.6826H4.08984V14.2215H5.52878V12.6826Z",
    fill: "#24292A"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M4.06406 21.9432H2.62512V23.4821H4.06406V21.9432Z",
    fill: "#24292A"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M4.06406 20.4044H2.62512V21.9433H4.06406V20.4044Z",
    fill: "#24292A"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M4.06406 18.8655H2.62512V20.4044H4.06406V18.8655Z",
    fill: "#24292A"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M4.06406 17.3268H2.62512V18.8657H4.06406V17.3268Z",
    fill: "#24292A"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M4.06406 15.7604H2.62512V17.2992H4.06406V15.7604Z",
    fill: "#24292A"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M4.06406 14.2214H2.62512V15.7603H4.06406V14.2214Z",
    fill: "#24292A"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M2.62522 20.4044H1.18628V21.9433H2.62522V20.4044Z",
    fill: "#24292A"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M2.62522 18.8655H1.18628V20.4044H2.62522V18.8655Z",
    fill: "#24292A"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M2.62522 17.3268H1.18628V18.8657H2.62522V17.3268Z",
    fill: "#24292A"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M2.62522 15.7604H1.18628V17.2992H2.62522V15.7604Z",
    fill: "#24292A"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3138 20.4044H35.8749V21.9433H37.3138V20.4044Z",
    fill: "#24292A"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3138 18.8655H35.8749V20.4044H37.3138V18.8655Z",
    fill: "#24292A"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3138 17.3268H35.8749V18.8657H37.3138V17.3268Z",
    fill: "#24292A"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3138 15.7604H35.8749V17.2992H37.3138V15.7604Z",
    fill: "#24292A"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8491 21.9432H34.4102V23.4821H35.8491V21.9432Z",
    fill: "#24292A"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8491 20.4044H34.4102V21.9433H35.8491V20.4044Z",
    fill: "#24292A"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8491 18.8655H34.4102V20.4044H35.8491V18.8655Z",
    fill: "#24292A"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8491 17.3268H34.4102V18.8657H35.8491V17.3268Z",
    fill: "#24292A"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8491 15.7604H34.4102V17.2992H35.8491V15.7604Z",
    fill: "#24292A"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8491 14.2214H34.4102V15.7603H35.8491V14.2214Z",
    fill: "#24292A"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4102 23.5098H32.9713V25.0486H34.4102V23.5098Z",
    fill: "#24292A"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4102 21.9432H32.9713V23.4821H34.4102V21.9432Z",
    fill: "#24292A"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4102 20.4044H32.9713V21.9433H34.4102V20.4044Z",
    fill: "#EDEFEF"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4102 18.8655H32.9713V20.4044H34.4102V18.8655Z",
    fill: "#EDEFEF"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4102 17.3268H32.9713V18.8657H34.4102V17.3268Z",
    fill: "#24292A"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4102 15.7604H32.9713V17.2992H34.4102V15.7604Z",
    fill: "#24292A"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4102 14.2214H32.9713V15.7603H34.4102V14.2214Z",
    fill: "#24292A"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4102 12.6826H32.9713V14.2215H34.4102V12.6826Z",
    fill: "#24292A"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9713 23.5098H31.5323V25.0486H32.9713V23.5098Z",
    fill: "#24292A"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9713 21.9432H31.5323V23.4821H32.9713V21.9432Z",
    fill: "#EDEFEF"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9713 20.4044H31.5323V21.9433H32.9713V20.4044Z",
    fill: "#24292A"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9713 18.8655H31.5323V20.4044H32.9713V18.8655Z",
    fill: "#24292A"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9713 17.3268H31.5323V18.8657H32.9713V17.3268Z",
    fill: "#24292A"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9713 15.7604H31.5323V17.2992H32.9713V15.7604Z",
    fill: "#24292A"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9713 14.2214H31.5323V15.7603H32.9713V14.2214Z",
    fill: "#24292A"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9713 12.6826H31.5323V14.2215H32.9713V12.6826Z",
    fill: "#24292A"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5324 23.5098H30.0935V25.0486H31.5324V23.5098Z",
    fill: "#24292A"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5324 21.9432H30.0935V23.4821H31.5324V21.9432Z",
    fill: "#EDEFEF"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5324 20.4044H30.0935V21.9433H31.5324V20.4044Z",
    fill: "#24292A"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5324 18.8655H30.0935V20.4044H31.5324V18.8655Z",
    fill: "#24292A"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5324 17.3268H30.0935V18.8657H31.5324V17.3268Z",
    fill: "#24292A"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5324 15.7604H30.0935V17.2992H31.5324V15.7604Z",
    fill: "#24292A"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5324 14.2214H30.0935V15.7603H31.5324V14.2214Z",
    fill: "#24292A"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5324 12.6826H30.0935V14.2215H31.5324V12.6826Z",
    fill: "#24292A"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0677 23.5098H28.6288V25.0486H30.0677V23.5098Z",
    fill: "#24292A"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0677 21.9432H28.6288V23.4821H30.0677V21.9432Z",
    fill: "#24292A"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0677 20.4044H28.6288V21.9433H30.0677V20.4044Z",
    fill: "#24292A"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0677 18.8655H28.6288V20.4044H30.0677V18.8655Z",
    fill: "#24292A"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0677 17.3268H28.6288V18.8657H30.0677V17.3268Z",
    fill: "#24292A"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0677 15.7604H28.6288V17.2992H30.0677V15.7604Z",
    fill: "#24292A"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0677 14.2214H28.6288V15.7603H30.0677V14.2214Z",
    fill: "#24292A"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0677 12.6826H28.6288V14.2215H30.0677V12.6826Z",
    fill: "#24292A"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6289 23.5098H27.1899V25.0486H28.6289V23.5098Z",
    fill: "#24292A"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6289 21.9432H27.1899V23.4821H28.6289V21.9432Z",
    fill: "#24292A"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6289 20.4044H27.1899V21.9433H28.6289V20.4044Z",
    fill: "#24292A"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6289 18.8655H27.1899V20.4044H28.6289V18.8655Z",
    fill: "#24292A"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6289 17.3268H27.1899V18.8657H28.6289V17.3268Z",
    fill: "#24292A"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6289 15.7604H27.1899V17.2992H28.6289V15.7604Z",
    fill: "#24292A"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6289 14.2214H27.1899V15.7603H28.6289V14.2214Z",
    fill: "#24292A"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6289 12.6826H27.1899V14.2215H28.6289V12.6826Z",
    fill: "#24292A"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1898 23.5098H25.7509V25.0486H27.1898V23.5098Z",
    fill: "#24292A"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1898 21.9432H25.7509V23.4821H27.1898V21.9432Z",
    fill: "#24292A"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1898 20.4044H25.7509V21.9433H27.1898V20.4044Z",
    fill: "#24292A"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1898 18.8655H25.7509V20.4044H27.1898V18.8655Z",
    fill: "#24292A"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1898 17.3268H25.7509V18.8657H27.1898V17.3268Z",
    fill: "#24292A"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1898 15.7604H25.7509V17.2992H27.1898V15.7604Z",
    fill: "#24292A"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1898 14.2214H25.7509V15.7603H27.1898V14.2214Z",
    fill: "#24292A"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1898 12.6826H25.7509V14.2215H27.1898V12.6826Z",
    fill: "#24292A"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7509 23.5098H24.312V25.0486H25.7509V23.5098Z",
    fill: "#24292A"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7509 21.9432H24.312V23.4821H25.7509V21.9432Z",
    fill: "#24292A"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7509 20.4044H24.312V21.9433H25.7509V20.4044Z",
    fill: "#24292A"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7509 18.8655H24.312V20.4044H25.7509V18.8655Z",
    fill: "#24292A"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7509 17.3268H24.312V18.8657H25.7509V17.3268Z",
    fill: "#24292A"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7509 15.7604H24.312V17.2992H25.7509V15.7604Z",
    fill: "#24292A"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7509 14.2214H24.312V15.7603H25.7509V14.2214Z",
    fill: "#24292A"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7509 12.6826H24.312V14.2215H25.7509V12.6826Z",
    fill: "#24292A"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M24.312 21.9432H22.873V23.4821H24.312V21.9432Z",
    fill: "#24292A"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M24.312 20.4044H22.873V21.9433H24.312V20.4044Z",
    fill: "#24292A"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M24.312 18.8655H22.873V20.4044H24.312V18.8655Z",
    fill: "#24292A"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M24.312 17.3268H22.873V18.8657H24.312V17.3268Z",
    fill: "#24292A"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M24.312 15.7604H22.873V17.2992H24.312V15.7604Z",
    fill: "#24292A"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M24.312 14.2214H22.873V15.7603H24.312V14.2214Z",
    fill: "#24292A"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8473 20.4044H21.4083V21.9433H22.8473V20.4044Z",
    fill: "#24292A"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8473 18.8655H21.4083V20.4044H22.8473V18.8655Z",
    fill: "#24292A"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8473 17.3268H21.4083V18.8657H22.8473V17.3268Z",
    fill: "#24292A"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8473 15.7604H21.4083V17.2992H22.8473V15.7604Z",
    fill: "#24292A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlasses);
export default __webpack_public_path__ + "static/media/glasses.dffc547b2067311cf9112855d792f2af.svg";
export { ForwardRef as ReactComponent };